import React from 'react'
import designImg from '../assets/images/projects/gasanze/Birembo (13 of 15).jpg'
import constructionImg from '../assets/images/projects/birembo/Birembo10.jpg'
import surveyImg from '../assets/images/projects/kanombe/Kanombe10.jpg'
import realestateImg from '../assets/images/projects/kanombe/Kanombe2.jpg'
import Sectionbreak from './Sectionbreak'

const services = [
  {
    title: 'Design Services',
    description:
      'Innovative architectural design tailored to client vision, sustainability, and modern aesthetics.',
    image: designImg,
  },
  {
    title: 'Construction Services',
    description:
      'Full-cycle construction—from foundation to finishing—with durability, safety, and efficiency at the core.',
    image: constructionImg,
  },
  {
    title: 'Land Surveying Services',
    description:
      'Accurate surveying using modern tools to inform successful development and legal compliance.',
    image: surveyImg,
  },
  {
    title: 'Real Estate Services',
    description:
      'Guiding clients through real estate investment, acquisition, and property development with integrity.',
    image: realestateImg,
  },
]

function Services() {
  return (
    <section id="services" className="pt-10 pb-10 px-6 bg-white">
      <Sectionbreak
      title='Our'
      highlight='Services'
      description='We offer comprehensive services to meet the demands of modern construction, architecture, and property development.'
      />

      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {services.map((service, index) => (
          <div
          key={index}
          className="bg-white rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105 duration-300 flex flex-col"
        >
          <img
            src={service.image}
            alt={service.title}
            className="h-48 w-full object-cover"
          />
          <div className="p-6 flex flex-col flex-grow">
            <h3 className="text-lg font-semibold text-blue-950 mb-2">
              {service.title}
            </h3>
            <p className="text-gray-600 text-lg font-light mb-6">
              {service.description}
            </p>
            <button className="mt-auto px-4 py-2 bg-teal-600 text-white rounded-md text-xs font-semibold hover:bg-teal-700 transition">
              Learn More
            </button>
          </div>
        </div>
        
        ))}
      </div>
    </section>
  )
}

export default Services
